<template>
    <div class="numpad-layour">
      <div class="keypad numbers">
        <KeyButton v-for="({normalKey, shiftKey}) in numberKeys"
          :key="normalKey"
          :normalKey="normalKey"
          :shiftKey="shiftKey"
          :shiftEnabled="shiftEnabled"
          v-if="editData !== 'username'"
          @click="clickHandle">
        </KeyButton>
      </div>
      <div class="keypad alphabets">
        <KeyButton v-for="({normalKey, shiftKey}) in qwertyKeys"
          :key="normalKey"
          :normalKey="normalKey"
          :shiftKey="shiftKey"
          :shiftEnabled="shiftEnabled"
          @click="clickHandle">
        </KeyButton>
      </div>
      <div class="keypad alphabets">
        <KeyButton v-for="({normalKey, shiftKey}) in asdfKeys"
          :key="normalKey"
          :normalKey="normalKey"
          :shiftKey="shiftKey"
          :shiftEnabled="shiftEnabled"
          @click="clickHandle">
        </KeyButton>
      </div>
      <div class="keypad alphabets">
        <KeyButton v-for="({normalKey, shiftKey}) in zxcKeys"
          :key="normalKey"
          :normalKey="normalKey"
          :shiftKey="shiftKey"
          :shiftEnabled="shiftEnabled"
          @click="clickHandle">
        </KeyButton>
      </div>
      <div class="keypad otherkeys">
        <KeyButton v-for="({normalKey, shiftKey}) in otherKeys"
          :key="normalKey"
          :normalKey="normalKey"
          :shiftKey="shiftKey"
          :shiftEnabled="shiftEnabled"
          @click="clickHandle">
        </KeyButton>
      </div>
    </div>
</template>
<script>
    import KeyButton from './key-button.vue'
    export default {
      data () {
        return {
          shiftEnabled: false,
          value: '',
          numberKeys: [
            {normalKey: '1', shiftKey: '1'},
            {normalKey: '2', shiftKey: '2'},
            {normalKey: '3', shiftKey: '3'},
            {normalKey: '4', shiftKey: '4'},
            {normalKey: '5', shiftKey: '5'},
            {normalKey: '6', shiftKey: '6'},
            {normalKey: '7', shiftKey: '7'},
            {normalKey: '8', shiftKey: '8'},
            {normalKey: '9', shiftKey: '9'},
            {normalKey: '0', shiftKey: '0'}
          ],
          qwertyKeys: [
            {normalKey: 'q', shiftKey: 'Q'},
            {normalKey: 'w', shiftKey: 'W'},
            {normalKey: 'e', shiftKey: 'E'},
            {normalKey: 'r', shiftKey: 'R'},
            {normalKey: 't', shiftKey: 'T'},
            {normalKey: 'y', shiftKey: 'Y'},
            {normalKey: 'u', shiftKey: 'U'},
            {normalKey: 'i', shiftKey: 'I'},
            {normalKey: 'o', shiftKey: 'O'},
            {normalKey: 'p', shiftKey: 'P'}
          ],
          asdfKeys: [
            {normalKey: 'a', shiftKey: 'A'},
            {normalKey: 's', shiftKey: 'S'},
            {normalKey: 'd', shiftKey: 'D'},
            {normalKey: 'f', shiftKey: 'F'},
            {normalKey: 'g', shiftKey: 'G'},
            {normalKey: 'h', shiftKey: 'H'},
            {normalKey: 'j', shiftKey: 'J'},
            {normalKey: 'k', shiftKey: 'K'},
            {normalKey: 'l', shiftKey: 'L'}
          ],
          zxcKeys: [
            {normalKey: '⇑', shiftKey: '⇧'},
            {normalKey: 'z', shiftKey: 'Z'},
            {normalKey: 'x', shiftKey: 'X'},
            {normalKey: 'c', shiftKey: 'C'},
            {normalKey: 'v', shiftKey: 'V'},
            {normalKey: 'b', shiftKey: 'B'},
            {normalKey: 'n', shiftKey: 'N'},
            {normalKey: 'm', shiftKey: 'M'},
            {normalKey: '←', shiftKey: '←'}
          ],
          otherKeys: [
            {normalKey: 'Space', shiftKey: 'Space'}
          ]

        }
      },
      props: ['editData', 'username'],
      computed: {
      },
      created: function () {
        if (this.username === null) {
          this.username = ''
        }
        this.value = this.username
      },
      methods: {
        clickHandle (val) {
          if (val === '⇑' || val === '⇧') {
            this.shiftEnabled = !this.shiftEnabled
            return
          }
          if (val === '←' && this.value.length) {
            this.value = this.value.split('').splice(0, this.value.length - 1).join('')
          } else if (val === '←') {
            return
          } else if (val === 'CE') {
            this.value = ''
          } else {
            if (val === 'Space') {
              this.value += ' '
            } else {
              this.value += val
            }
          }
          this.$emit('change', this.value)
        }
      },
      components: {
        KeyButton
      }
    }
</script>
<style scoped>
  .numpad-layour {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    height: 95%;
    width: 100%;
    margin: 0 auto;
    padding: 10px 0;
    background-color: rgba(255,255,255,0.19);
  }
  .numpad-layour .keypad {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
  }
  @media only screen and (min-width: 2000px) {
    .numpad-layour {
      height: 100%;
      padding: 2% 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/keypad.vue